import { render, staticRenderFns } from "./LastOrders.vue?vue&type=template&id=7d114555&scoped=true"
import script from "./LastOrders.vue?vue&type=script&lang=js"
export * from "./LastOrders.vue?vue&type=script&lang=js"
import style0 from "./LastOrders.vue?vue&type=style&index=0&id=7d114555&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d114555",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d114555')) {
      api.createRecord('7d114555', component.options)
    } else {
      api.reload('7d114555', component.options)
    }
    module.hot.accept("./LastOrders.vue?vue&type=template&id=7d114555&scoped=true", function () {
      api.rerender('7d114555', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LastOrders.vue"
export default component.exports